import React from 'react';
import PropTypes from 'prop-types';



const Cita = ({deleteMeeting, cita : { mascota, propietario, fecha, hora, sintomas, id }}) => (
    <div>
        <p className="cita">
            Mascota:
            <span className="cita__result">{mascota}</span>
        </p>

        <p className="cita">
            Dueño:
            <span className="cita__result">{propietario}</span>
        </p>

        <p className="cita">
            Fecha:
            <span className="cita__result">{fecha}</span>
        </p>

        <p className="cita">
            Hora:
            <span className="cita__result">{hora}</span>
        </p>

        <p className="cita">
            Síntomas:
            <span className="cita__result">{sintomas}</span>
        </p>

        <button className="btn" onClick={ () =>deleteMeeting(id) }>
            Eliminar &times;
        </button>
    </div>
);
Cita.propTypes = {
    cita: PropTypes.object.isRequired,
    deleteMeeting: PropTypes.func.isRequired
}

export default Cita;